<template>
	<div v-if="!isLoading">
<!--      <p class="back_link">-->
<!--          <a href="/bussines_companies">-->
<!--              <svg width="14.000000" height="11.000000" viewBox="0 0 14 11" fill="none"-->
<!--                   xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">-->
<!--                  <path id="Vector 1 (Border)"-->
<!--                        d="M2.65796 6.32568L5.72949 9.58704C6.03735 9.91406 6.03735 10.4279 5.72949 10.7548C5.42139 11.0818 4.93774 11.0818 4.62964 10.7548L0.230957 6.08386C-0.0769043 5.75696 -0.0769043 5.24304 0.230957 4.91614L4.62964 0.245239C4.93774 -0.0817871 5.42139 -0.0817871 5.72949 0.245239C6.03735 0.572144 6.03735 1.08594 5.72949 1.41296L2.65796 4.67432L13.2224 4.67432C13.658 4.67432 14 5.0376 14 5.5C14 5.9624 13.658 6.32568 13.2224 6.32568L2.65796 6.32568Z"-->
<!--                        fill="#EC983F" fill-opacity="1.000000" fill-rule="evenodd"/>-->
<!--              </svg>-->
<!--              <span>Бизнес-площадки</span></a>-->
<!--      </p>-->
      <FilmList
				:films="projects"
			></FilmList>
	</div>
	<div v-else><div style="text-align: center"><Spin></Spin></div></div>
</template>
<script setup>
import { ref } from "vue"
import {Spin} from "ant-design-vue"
import axios from "axios";
import FilmList from "@/components/FilmList.vue";

let projects = ref([]);
let isLoading = ref(false);


async function getData() {
  isLoading.value = true;
  const response = await axios.get('/get_moviestart_distribution_films');
  projects.value = response.data;
  isLoading.value = false;
}
getData();

</script>
<style>
.back_link {
    padding-left: 30px;
}
</style>